import * as $ from 'jquery';
import * as countryStateSetup from '../modules/countryStateSetup';
import * as fileInput from "../modules/fileInput";
import * as formValidation from "../modules/formValidation";
import TranslationsService from '../services/translationsService'
import 'url-search-params-polyfill';

declare const grecaptcha: any;

namespace PFF.controllers.registerProduct {

	// Init translations service
	const translationsService = TranslationsService.getInstance();
	let translationStrings = JSON.parse($("#translations").html());
	translationsService.init(translationStrings);

	let $form = $('form');
	let $registerForm = $('#register-product-form');
	let $alertSuccess = $('.js-alert-success');
	let $alertDanger = $('.js-alert-danger');
	let $alertDangerFields = $('.js-alert-danger-fields');
	let $errorList = $('.js-issues-need-correction');
	let $firstName = $('#first-name');
	let $lastName = $('#last-name');
	let $email = $('#email');
	let $emailConfirm = $('#email-confirm');
	let $address = $('#address');
	let $address2 = $('#address2');
	let $country = $('#country');
	let $city = $('#city');
	let $stateProvince = $('#state-province');
	let $postalCode = $('#postal-code');
	let $phone = $('#phone');
	let $upc = $('#upc');
	let $datePurchased = $('#date-purchased');
	let $purchaseLocation = $('#purchase-location');
	let $uploadDocument = $('#upload-document');
	let uploadPhotoTranslation = translationsService.translate('FormValidationErrors.UploadPhotoRequired');

	let $submit = $('#submit');
	let $pleaseWait = $('#please-wait');

	//patternChecks
	let zipcodePattern = /^(\d{5}(-\d{4})?|[A-Z]\d[A-Z] ?\d[A-Z]\d)$/;
	let datePattern = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;

	let constraints = {
		'first-name': {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.FirstNameRequired')
			}
		},
		'last-name': {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.LastNameRequired')
			}
		},
		email: {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.EmailRequired')
			},
			email: {
				message: '^' + translationsService.translate('FormValidationErrors.EmailInvalid')
			}
		},
		'email-confirm': {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.ConfirmEmailRequired')
			},
			equality: {
				attribute: 'email',
				message: '^' + translationsService.translate('FormValidationErrors.ConfirmEmailInvalid')
			}
		},
		address: {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.AddressRequired')
			}
		},
		address2: {
			presence: false
		},
		country: {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.CountryRequired')
			}
		},
		city: {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.CityRequired')
			}
		},
		'state-province': {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.StateRequired')
			}
		},
		'postal-code': {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.PostalCodeRequired')
			},
			format: {
				pattern: zipcodePattern,
				message: '^' + translationsService.translate('FormValidationErrors.PostalCodeFormat')
			}
		},
		phone: {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.PhoneRequired')
			}
		},
		upc: {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.UPCRequired')
			}
		},
		'date-purchased': {
			presence: {
				allowEmpty: false,
				message:'^' + translationsService.translate('FormValidationErrors.DatePurchasedRequired')
			},
			format: {
				pattern: datePattern,
				message:'^' + translationsService.translate('FormValidationErrors.DateInvalid')
			},
			datetime: {
				dateOnly: true,
				latest: Date.now(),
				message:'^' + translationsService.translate('FormValidationErrors.DateFutureDate')
			}

		},
		'purchase-location': {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.PurchaseLocationRequired')
			}
		},
		'recaptcha-token': {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.CaptchaRequired')
			}
		}
	};


	let validateField = function () {
		$(this).addClass('dirty');
		if (formValidation.validateWrapper({
			constraints: constraints,
			values: {
				'first-name': $firstName.val(),
				'last-name': $lastName.val(),
				email: $email.val(),
				'email-confirm': $emailConfirm.val(),
				address: $address.val(),
				address2: $address2.val(),
				country: $country.val(),
				city: $city.val(),
				'state-province': $stateProvince.val(),
				'postal-code': $postalCode.val(),
				phone: $phone.val(),
				upc: $upc.val(),
				'date-purchased': $datePurchased.val(),
				'purchase-location': $purchaseLocation.val(),
				'recaptcha-token': grecaptcha.getResponse()
			}
		})) {
			// check form
		}
	};

	let setupHandlers = function(){
		//waiting a second here so that the fileinput.ts binding that happens can be turned off.
		setTimeout(function(){
			$('input[type=file]').off('change.file');
			$('#upload-document').on('change.upload', function(){
				var $value = $(this).siblings('.js-file-input-value');
				var $this = $(this);
				if ( this.files && this.files[0] ) {
					if($this.data("accept")) {
						let fileAssocArray = $this.data("accept").split(',');
						let fileName = this.files[0].name;
						let fileExt = fileName.split(/[. ]+/).pop().toLowerCase();
						// console.log(`${fileAssocArray}, ${fileName}, ${fileExt}`);

						if(fileAssocArray.indexOf(`.${fileExt}`) > -1) {
							$value.html( this.files[0].name );
							$value.append('<i class="icon icon-close file-input-close js-reset-file" title="Remove Image"></i>');
							validateField();
						} else {
							alert(`.${fileExt} files are not allowed. Please choose one of the following file types: (${fileAssocArray})`);
						}
					} else {
						$value.html( this.files[0].name );
						$value.append('<i class="icon icon-close file-input-close js-reset-file" title="Remove Image"></i>');
						validateField();

					}
				} else {
					$value.html('');
					validateField();

				}
			});
		}, 1000);

		$('body').on('click.register', '.js-reset-file', function(e){
			validateField();
			e.preventDefault();
		});
	};

	let setUPCValue = function(){
		let urlParams = new URLSearchParams(window.location.search);
		let upcParam = urlParams.get('upc');

		if(upcParam && upcParam.length) {
			$upc.val(upcParam);
		}
	};

	let trackRegisterProductSubmit = function () {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event' : 'register_a_product_submitted'
		});
		console.log(window.dataLayer);
	};


	let inputEventListeners = function () {
		$firstName.on('blur change', validateField);
		$lastName.on('blur change', validateField);
		$email.on('blur change', validateField);
		$emailConfirm.on('blur change', validateField);
		$address.on('blur change', validateField);
		$address2.on('blur change', validateField);
		$country.on('blur change', validateField);
		$city.on('blur change', validateField);
		$stateProvince.on('blur change', validateField);
		$postalCode.on('blur change', validateField);
		$phone.on('blur change', validateField);
		$upc.on('blur change', validateField);
		$datePurchased.on('blur change', validateField);
		$purchaseLocation.on('blur change', validateField);
		grecaptcha.ready(() => {
			grecaptcha.render( document.getElementById('g-recaptcha'), {
				callback: validateField
			});
		});
	};

	let submitEventListener = function () {
		$submit.on('click', function (e) {
			e.preventDefault();

			$submit.addClass('hidden');
			$pleaseWait.removeClass('hidden');

			$('.js-alert').addClass('hidden');

			let $fileHasValue = $uploadDocument.val() != "";

			if (formValidation.validateWrapperSubmit({
					constraints: constraints,
					values: {
						'first-name': $firstName.val(),
						'last-name': $lastName.val(),
						email: $email.val(),
						'email-confirm': $emailConfirm.val(),
						address: $address.val(),
						address2: $address2.val(),
						country: $country.val(),
						city: $city.val(),
						'state-province': $stateProvince.val(),
						'postal-code': $postalCode.val(),
						phone: $phone.val(),
						upc: $upc.val(),
						'date-purchased': $datePurchased.val(),
						'purchase-location': $purchaseLocation.val(),
						'recaptcha-token': grecaptcha.getResponse()
					}
				}) && $fileHasValue === true) {
				// check form
			} else {
				if($fileHasValue === false) {
					$(`<li>${uploadPhotoTranslation}</li>`).appendTo($errorList);
				}
				$alertDangerFields.removeClass('hidden');
				$("html, body").animate({ scrollTop: 0 }, 500);
				$submit.removeClass('hidden');
				$pleaseWait.addClass('hidden');
				return;
			}

			$.get("/api/salesforce/validate-upc?upc=" + $upc.val())
				.done(function (result) {
					if (result) {
						let data = new FormData();

						let contactInfo = JSON.stringify({
							FirstName: $firstName.val(),
							LastName: $lastName.val(),
							Email: $email.val(),
							Address1: $address.val(),
							Address2: $address2.val(),
							Country: $country.val(),
							City: $city.val(),
							State: $stateProvince.val(),
							PostalCode: $postalCode.val(),
							Phone: $phone.val()
						});

						let product = JSON.stringify({
							UpcCode: $upc.val(),
							DatePurchased: $datePurchased.val(),
							PurchaseLocation: $purchaseLocation.val()
						});

						data.append("ContactInfo", contactInfo);
						data.append("Product", product);
						data.append("File", $uploadDocument[0].files[0]);

						$.ajax({
							url: '/api/salesforce/post-register-product',
							type: 'POST',
							dataType: 'json',
							data: data,
							processData: false,
							contentType: false // not json
						})
							.done(function () {
								$alertSuccess.removeClass('hidden');
								$registerForm[0].reset();
								formValidation.resetForm($form);
								$('.js-file-input-value').text('');
								trackRegisterProductSubmit();
							})
							.fail(function (response) {
								$alertDanger
									.removeClass('hidden')
									.find('.alert__text');
									//.text(response.responseJSON.ExceptionMessage);
							})
							.always(function () {
								window.scrollTo(0, 0);
								$submit.removeClass('hidden');
								$pleaseWait.addClass('hidden');
							});
					} else {
						let upcNotValid = translationsService.translate('FormValidationErrors.UPCCodeNotValid');
						$alertDanger
							.removeClass('hidden')
							.find('.js-alert-text')
							// TODO: verify this text
							.text(upcNotValid);

						window.scrollTo(0, 0);
						$submit.removeClass('hidden');
						$pleaseWait.addClass('hidden');
					}
				})
				.fail(function (response) {
					$alertDanger
						.removeClass('hidden')
						.find('.js-alert-text');
						//.text(response.responseJSON.ExceptionMessage);

					window.scrollTo(0, 0);
					$submit.removeClass('hidden');
					$pleaseWait.addClass('hidden');
				});
		});
	};

	export function init() {
		setupHandlers();
		countryStateSetup.init($country, $stateProvince);
		fileInput.init();
		inputEventListeners();
		submitEventListener();
		setUPCValue();
	}
}

PFF.controllers.registerProduct.init();



// WEBPACK FOOTER //
// ./js/PFF/controllers/registerProduct.ts